import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import ExtranetApp from './containers/ExtranetApp';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { publicRoutes, privateRoutes } from './extranetRoutes';
import store from './store/extranetStore';
import ExtranetMenuAppBar from './components/ExtranetMenuAppBar';
import {
    getSynchroActiveUser,
    synchronization,
    initSynchronisations,
    getDefaultSyncState,
} from "./redux/synchro/extranetSynchroActions";

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <ExtranetApp appBar={<ExtranetMenuAppBar getSynchroActiveUser={getSynchroActiveUser} synchronization={synchronization} />}
                initSynchronisations={initSynchronisations} contextualProps={{}}
                getDefaultSyncState={getDefaultSyncState} publicRoutes={publicRoutes} privateRoutes={privateRoutes} />
        </BrowserRouter>
    </Provider>
    , document.getElementById('root')
);

(function () {
    if ("Notification" in window) {
        var permission = Notification.permission;

        if (permission === "denied" || permission === "granted") {
            return;
        }

        Notification.requestPermission();
    }
})();
